module.exports = __webpack_public_path__ + "img/30.4b4fe7ae.png";